let mode;

if (process.env.REACT_APP_MODE) {
  mode = process.env.REACT_APP_MODE;
} else {
  mode = "dev";
}

var localURL = "http://localhost:3000/dev";

export var demoAuthUrl =
  "https://toyg4ps5yl.execute-api.us-east-1.amazonaws.com/dev";

// server_coreSetURL1;
export var awsUrl =
  "https://o7sy8w29zc.execute-api.us-east-1.amazonaws.com/dev";
var awsUrlBeta = "https://gu78z9nzbf.execute-api.us-east-1.amazonaws.com/beta";
var awsUrlProd = "https://6l0oqtfoxh.execute-api.us-east-1.amazonaws.com/prod";

export var awsAcordUpload =
  "https://5swuplkv50.execute-api.us-east-1.amazonaws.com/dev";
var awsAcordUploadProd =
  "https://ofmfwmokg6.execute-api.us-east-1.amazonaws.com/prod";

// server_coreSetURL2;
export var awsUrl2 =
  "https://ni8d033b10.execute-api.us-east-1.amazonaws.com/dev";
var awsUrlBeta2 = "https://tgp73gylfg.execute-api.us-east-1.amazonaws.com/beta";
var awsUrlProd2 = "https://0pcadwg8hi.execute-api.us-east-1.amazonaws.com/prod";

export var awsUrl3 =
  "https://5b68wiw3m1.execute-api.us-east-1.amazonaws.com/dev";
var awsUrlBeta3 = "https://rxa5cyl6el.execute-api.us-east-1.amazonaws.com/beta";
var awsUrlProd3 = "https://pvez4ipsqf.execute-api.us-east-1.amazonaws.com/prod";

export var pibitUrl =
  "https://qypm1jivib.execute-api.us-east-1.amazonaws.com/dev";
var pibitUrlBeta =
  "https://wy69228799.execute-api.us-east-1.amazonaws.com/beta";
var pibitUrlProd =
  "https://thcgya5ipc.execute-api.us-east-1.amazonaws.com/prod";

// This key is added in db to differentiate client, since for dev environment pibit will have single client code.
// Client code for prod will differ.
export var clientIdInternal = "103-1";
var clientIdInternalBeta = "103-4";
var clientIdInternalProd = 80;

// for dev and beta environment client-id for all instances will be same, but it will differ in prod.
export var clientId = 103;
var clientIdProd = 80;

// dashboard URL
export var dashboardUrl =
  "https://dmuwt3vd0e.execute-api.us-east-1.amazonaws.com/dev";
var dashboardUrlProd = "";
//mode = "local2"
if (mode === "local") {
  awsUrl = awsUrl2 = localURL;
} else if (mode === "local1") {
  awsUrl = localURL;
  awsAcordUpload = localURL;
} else if (mode === "local2") {
  awsUrl2 = localURL;
  awsAcordUpload = localURL;
} else if (mode === "locald") {
  dashboardUrl = localURL;
} else if (mode === "prod") {
  awsUrl = awsUrlProd;
  awsUrl2 = awsUrlProd2;
  awsUrl3 = awsUrlProd3;
  dashboardUrl = dashboardUrlProd;
  pibitUrl = pibitUrlProd;
  clientIdInternal = clientIdInternalProd;
  clientId = clientIdProd;
  awsAcordUpload = awsAcordUploadProd;
} else if (mode === "beta") {
  awsUrl = awsUrlBeta;
  awsUrl2 = awsUrlBeta2;
  awsUrl3 = awsUrlBeta3;
  dashboardUrl = dashboardUrlProd;
  pibitUrl = pibitUrl;
  clientIdInternal = clientIdInternalBeta;
  clientId = clientId;
} else if (mode === "dev") {
  clientIdInternal = clientIdInternal;
  clientId = clientId;
}

export const versionNumber = "1.0.4 (m)";
